var _circle, _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgB3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 90,
    viewBox: "0 0 136 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 88.5,
    cy: 45.5,
    r: 44.5,
    fill: "#FEF6F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.343 77.3572C128.138 69.2073 133.643 57.5568 133.643 44.6206C133.643 19.9784 113.666 0 89.022 0C64.3798 0 44.4023 19.9784 44.4023 44.6206C44.4023 57.5568 49.9074 69.2073 58.7024 77.3572H119.343Z",
    fill: "#DAEBFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.6065 77.2055H134.603C135.035 76.45 135.286 75.5771 135.286 74.6454C135.286 71.7827 132.959 69.4626 130.089 69.4626C128.984 69.4626 127.96 69.8096 127.118 70.3965C125.836 68.4955 123.661 67.244 121.191 67.244C120.62 67.244 120.068 67.3182 119.537 67.4446C118.887 63.2994 115.302 60.1246 110.964 60.1246C108.298 60.1246 105.916 61.3251 104.322 63.2101H72.5857C71.0109 61.0053 68.4325 59.5626 65.5113 59.5626C61.6582 59.5626 58.3947 62.0678 57.2583 65.5319C56.8443 65.441 56.417 65.39 55.9769 65.39C53.339 65.39 51.1063 67.1109 50.3389 69.4876C49.6099 69.0475 48.7574 68.7898 47.8422 68.7898C45.1683 68.7898 43 70.9524 43 73.62C43 75.045 43.6224 76.3215 44.6065 77.2055Z",
    fill: "#355468"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 0,
    width: 90,
    height: 90
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.643 44.6206C133.643 69.2638 113.666 89.2412 89.022 89.2412C64.3798 89.2412 44.4023 69.2638 44.4023 44.6206C44.4023 19.9784 64.3798 0 89.022 0C113.666 0 133.643 19.9784 133.643 44.6206Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.2322 16.2743C96.6251 13.1304 93.657 11.0532 90.5295 11.5161C89.4977 7.91511 86.1944 5.27698 82.2708 5.27698C79.0867 5.27698 76.3132 7.01652 74.8279 9.59535C74.4509 9.53193 74.0664 9.49157 73.6721 9.49157C69.8487 9.49157 66.75 12.5992 66.75 16.4316C66.75 20.2657 69.8487 23.3725 73.6721 23.3725H91.3937V23.37C91.7667 23.3692 92.1446 23.3362 92.525 23.2629C95.7494 22.637 97.8574 19.5079 97.2322 16.2743Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.2051 77.5809H116.808V40.4749H61.2051V77.5809Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9163 65.0307V70.0043H66.1325V65.0307H71.9163Z",
    fill: "#FBCCC8",
    stroke: "#FEF6F5",
    strokeWidth: 2.64
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.748 71.4101H74.2996V69.5503H63.748V71.4101Z",
    fill: "#FEF6F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.389 65.0307V70.0043H106.605V65.0307H112.389Z",
    fill: "#FBCCC8",
    stroke: "#FEF6F5",
    strokeWidth: 2.64
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.219 71.4101H114.77V69.5503H104.219V71.4101Z",
    fill: "#FEF6F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3523 59.4339V76.0518H78.9743V59.4339H99.3523Z",
    fill: "#FBCCC8",
    stroke: "#FEF6F5",
    strokeWidth: 2.64
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.9004 77.5809H119.32V75.0251H58.9004V77.5809Z",
    fill: "#FEF6F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.8125 55.205H73.2363V43.0249H64.8125V55.205Z",
    fill: "#FEF6F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.4941 55.205H71.5563V44.6541H66.4941V55.205Z",
    fill: "#FBCCC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4941 48.1989H71.5563",
    stroke: "#FEF6F5",
    strokeWidth: 1.21065
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.8125 41.8189C64.8125 40.5332 66.6987 39.4905 69.0244 39.4905C71.3509 39.4905 73.2363 40.5332 73.2363 41.8189",
    fill: "#FBCCC8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.748 56.7831H74.2996V55.205H63.748V56.7831Z",
    fill: "#FEF6F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.285 55.205H113.709V43.0249H105.285V55.205Z",
    fill: "#FEF6F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.965 55.205H112.027V44.6541H106.965V55.205Z",
    fill: "#FBCCC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.965 48.1989H112.027",
    stroke: "#FEF6F5",
    strokeWidth: 1.21065
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.283 41.8189C105.283 40.5332 107.169 39.4905 109.495 39.4905C111.821 39.4905 113.707 40.5332 113.707 41.8189",
    fill: "#FBCCC8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.219 56.7831H114.77V55.205H104.219V56.7831Z",
    fill: "#FEF6F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0454 44.3449V53.885H81.4216V44.3449H97.0454Z",
    fill: "#FBCCC8",
    stroke: "#FEF6F5",
    strokeWidth: 2.64
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.233 43.0254V55.2055",
    stroke: "#FEF6F5",
    strokeWidth: 1.21065
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.1016 41.8189C80.1016 40.5332 84.1902 39.4905 89.2335 39.4905C94.2768 39.4905 98.3654 40.5332 98.3654 41.8189",
    fill: "#FBCCC8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.1016 56.7831H99.3683V55.205H79.1016V56.7831Z",
    fill: "#FBCCC8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.4296 71.4099H85.0896C84.586 71.4099 84.1777 71.0005 84.1777 70.4956V65.7844C84.1777 65.2795 84.586 64.8701 85.0896 64.8701H93.4296C93.9332 64.8701 94.3407 65.2795 94.3407 65.7844V70.4956C94.3407 71.0005 93.9332 71.4099 93.4296 71.4099Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8808 66.9673C93.0786 66.9673 93.239 67.1277 93.239 67.3256C93.239 67.5082 93.1024 67.659 92.9257 67.6811L92.8808 67.6839H85.4911C85.2932 67.6839 85.1328 67.5234 85.1328 67.3256C85.1328 67.1429 85.2695 66.9922 85.4462 66.9701L85.4911 66.9673H92.8808Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1936 68.7587C90.3915 68.7587 90.5519 68.9191 90.5519 69.117C90.5519 69.2996 90.4152 69.4503 90.2386 69.4725L90.1936 69.4752H85.4911C85.2932 69.4752 85.1328 69.3148 85.1328 69.117C85.1328 68.9343 85.2695 68.7836 85.4462 68.7615L85.4911 68.7587H90.1936Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1367 65.5639L89.2591 63.0641L93.3814 65.5639",
    stroke: "url(#paint1_linear)",
    strokeWidth: 1.21065
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.02 40.4749H54.9889V39.1628L54.3145 38.2304L83.1151 29.1193H89.0045H95.1469L123.718 38.2304L123.02 39.1628V40.4749Z",
    fill: "#FEF6F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.149 29.1196H83.0703V24.9066L84.4825 25.7303H93.7147L95.149 24.9066V29.1196Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.719 37.7681V38.5896H54.3164V37.7681H123.719Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.8125 62.8304C64.8125 61.5447 66.6987 60.502 69.0244 60.502C71.3509 60.502 73.2363 61.5447 73.2363 62.8304",
    fill: "#FBCCC8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.283 62.8304C105.283 61.5447 107.169 60.502 109.495 60.502C111.821 60.502 113.707 61.5447 113.707 62.8304",
    fill: "#FBCCC8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.1113 58.8245H118.903V50.7631H59.1113V58.8245Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.363793,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.0684 60.6077H62.6512V62.3991C62.6512 63.3885 61.8492 64.1905 60.8598 64.1905C59.8704 64.1905 59.0684 63.3885 59.0684 62.3991V60.6077ZM87.2831 60.6077H90.8659V62.3991C90.8659 63.3885 90.0639 64.1905 89.0745 64.1905C88.0851 64.1905 87.2831 63.3885 87.2831 62.3991V60.6077ZM76.5345 60.6077H73.4004V62.623C73.4004 63.4887 74.1022 64.1905 74.9679 64.1905C75.8336 64.1905 76.5354 63.4887 76.5354 62.623V62.457C76.566 63.4196 77.3559 64.1905 78.3259 64.1905C79.3153 64.1905 80.1173 63.3885 80.1173 62.3991V60.6077H76.5354H76.5345ZM101.615 60.6077H104.75H104.75H108.332V62.3991C108.332 63.3885 107.53 64.1905 106.541 64.1905C105.567 64.1905 104.774 63.4126 104.75 62.4439V62.623C104.75 63.4887 104.048 64.1905 103.183 64.1905C102.317 64.1905 101.615 63.4887 101.615 62.623V62.4166C101.606 63.3979 100.807 64.1905 99.8237 64.1905C98.8344 64.1905 98.0323 63.3885 98.0323 62.3991V60.6077H101.615ZM69.8164 60.6077H66.2346H66.2336H62.6518V62.3991C62.6518 63.3885 63.4538 64.1905 64.4432 64.1905C65.4177 64.1905 66.2105 63.4124 66.2341 62.4435C66.2577 63.4124 67.0505 64.1905 68.025 64.1905C69.0144 64.1905 69.8164 63.3885 69.8164 62.3991V60.6077ZM94.4493 60.6077H98.0317V62.3991C98.0317 63.3885 97.2297 64.1905 96.2403 64.1905C95.2603 64.1905 94.464 63.4035 94.4491 62.427C94.4342 63.4035 93.638 64.1905 92.6579 64.1905C91.6685 64.1905 90.8665 63.3885 90.8665 62.3991V60.6077H94.4489H94.4493ZM83.7 60.6077H80.1179V62.3991C80.1179 63.3885 80.9199 64.1905 81.9093 64.1905C82.8867 64.1905 83.6813 63.4078 83.7004 62.435C83.7195 63.4078 84.5141 64.1905 85.4914 64.1905C86.4808 64.1905 87.2829 63.3885 87.2829 62.3991V60.6077H83.7007H83.7ZM108.333 60.6077H111.915H111.916H115.498V62.3991C115.498 63.3885 114.696 64.1905 113.706 64.1905C112.73 64.1905 111.936 63.409 111.915 62.4373C111.895 63.409 111.101 64.1905 110.124 64.1905C109.135 64.1905 108.333 63.3885 108.333 62.3991V60.6077ZM73.3998 60.6077H69.817V62.3991C69.817 63.3885 70.619 64.1905 71.6084 64.1905C72.5978 64.1905 73.3998 63.3885 73.3998 62.3991V60.6077ZM119.081 60.6077H115.498V62.3991C115.498 63.3885 116.3 64.1905 117.29 64.1905C118.279 64.1905 119.081 63.3885 119.081 62.3991V60.6077Z",
    fill: "#355468"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.0684 58.3684H62.6512V60.1598C62.6512 61.1492 61.8492 61.9513 60.8598 61.9513C59.8704 61.9513 59.0684 61.1492 59.0684 60.1598V58.3684ZM87.2831 58.3684H90.8659V60.1598C90.8659 61.1492 90.0639 61.9513 89.0745 61.9513C88.0851 61.9513 87.2831 61.1492 87.2831 60.1598V58.3684ZM76.5345 58.3684H73.4004V60.3838C73.4004 61.2495 74.1022 61.9513 74.9679 61.9513C75.8336 61.9513 76.5354 61.2495 76.5354 60.3838V60.2178C76.566 61.1803 77.3559 61.9513 78.3259 61.9513C79.3153 61.9513 80.1173 61.1492 80.1173 60.1598V58.3684H76.5354H76.5345ZM101.615 58.3684H104.75H104.75H108.332V60.1598C108.332 61.1492 107.53 61.9513 106.541 61.9513C105.567 61.9513 104.774 61.1733 104.75 60.2046V60.3838C104.75 61.2495 104.048 61.9513 103.183 61.9513C102.317 61.9513 101.615 61.2495 101.615 60.3838V60.1774C101.606 61.1587 100.807 61.9513 99.8237 61.9513C98.8344 61.9513 98.0323 61.1492 98.0323 60.1598V58.3684H101.615ZM69.8164 58.3684H66.2346H66.2336H62.6518V60.1598C62.6518 61.1492 63.4538 61.9513 64.4432 61.9513C65.4177 61.9513 66.2105 61.1731 66.2341 60.2043C66.2577 61.1731 67.0505 61.9513 68.025 61.9513C69.0144 61.9513 69.8164 61.1492 69.8164 60.1598V58.3684ZM94.4493 58.3684H98.0317V60.1598C98.0317 61.1492 97.2297 61.9513 96.2403 61.9513C95.2603 61.9513 94.464 61.1643 94.4491 60.1877C94.4342 61.1643 93.638 61.9513 92.6579 61.9513C91.6685 61.9513 90.8665 61.1492 90.8665 60.1598V58.3684H94.4489H94.4493ZM83.7 58.3684H80.1179V60.1598C80.1179 61.1492 80.9199 61.9513 81.9093 61.9513C82.8867 61.9513 83.6813 61.1685 83.7004 60.1957C83.7195 61.1685 84.5141 61.9513 85.4914 61.9513C86.4808 61.9513 87.2829 61.1492 87.2829 60.1598V58.3684H83.7007H83.7ZM108.333 58.3684H111.915H111.916H115.498V60.1598C115.498 61.1492 114.696 61.9513 113.706 61.9513C112.73 61.9513 111.936 61.1698 111.915 60.198C111.895 61.1698 111.101 61.9513 110.124 61.9513C109.135 61.9513 108.333 61.1492 108.333 60.1598V58.3684ZM73.3998 58.3684H69.817V60.1598C69.817 61.1492 70.619 61.9513 71.6084 61.9513C72.5978 61.9513 73.3998 61.1492 73.3998 60.1598V58.3684ZM119.081 58.3684H115.498V60.1598C115.498 61.1492 116.3 61.9513 117.29 61.9513C118.279 61.9513 119.081 61.1492 119.081 60.1598V58.3684Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4701 51.6506C50.873 51.6506 48.7676 53.756 48.7676 56.3531C48.7676 58.9503 50.873 61.0556 53.4701 61.0556C56.0672 61.0556 58.1726 58.9503 58.1726 56.3531C58.1726 53.756 56.0672 51.6506 53.4701 51.6506Z",
    fill: "#AC3D38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4708 52.5463C55.5733 52.5463 57.2776 54.2506 57.2776 56.3531C57.2776 58.4555 55.5733 60.1598 53.4708 60.1598C51.3684 60.1598 49.6641 58.4555 49.6641 56.3531C49.6641 54.2506 51.3684 52.5463 53.4708 52.5463Z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0688 54.1138V55.0095H57.2773V54.1138H59.0688Z",
    fill: "#AC3D38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8579 57.8141V58.7098H57.2773V57.8141H59.8579Z",
    fill: "#AC3D38"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.303 39.071C146.861 36.7813 144.699 35.2691 142.422 35.606C141.67 32.9835 139.265 31.0627 136.408 31.0627C134.09 31.0627 132.07 32.3295 130.988 34.2074C130.714 34.1613 130.434 34.1316 130.146 34.1316C127.363 34.1316 125.105 36.3942 125.105 39.1855C125.105 41.9769 127.363 44.2394 130.146 44.2394H143.051V44.237C143.323 44.237 143.598 44.2131 143.875 44.1595C146.223 43.7041 147.758 41.425 147.303 39.071Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.4664 24.7347C47.1025 22.8469 45.3198 21.599 43.441 21.8766C42.8208 19.7137 40.8377 18.129 38.4807 18.129C36.5674 18.129 34.9022 19.1742 34.0092 20.7227C33.7841 20.6848 33.5525 20.6609 33.3159 20.6609C31.0189 20.6609 29.1582 22.5265 29.1582 24.8294C29.1582 27.1315 31.0189 28.9979 33.3159 28.9979H43.9594V28.9962C44.1837 28.9962 44.4104 28.9764 44.6396 28.932C46.5759 28.5556 47.8419 26.6768 47.4664 24.7347Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.351 57.8141V58.7098H58.6641V57.8141H119.351Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.363793,
    x: 61.3086,
    y: 40.4541,
    width: 55.5343,
    height: 3.58285,
    fill: "#355468"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.626 35.3037V36.1994H60.0762V35.3037H117.626Z",
    fill: "url(#paint7_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.979 33.0645V33.9602H67.1699V33.0645H110.979Z",
    fill: "url(#paint8_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.51 30.6013V31.497H75.6387V30.6013H102.51Z",
    fill: "url(#paint9_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.6953 20.2054C70.2537 20.2054 75.5703 14.8888 75.5703 8.33044C75.5703 1.77206 70.2537 -3.54456 63.6953 -3.54456C57.1369 -3.54456 51.8203 1.77206 51.8203 8.33044C51.8203 14.8888 57.1369 20.2054 63.6953 20.2054Z",
    fill: "#F7DC57"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.835 70.3528H129.236V73.8015H127.403L126.93 71.9346H124.277L124.207 75.173H132.189L130.835 70.3528Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.531 72.3546H124.242V69.108H120.531V72.3546Z",
    fill: "#F05253"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.39 69.8014C129.39 70.0054 129.225 70.1714 129.021 70.1714C128.817 70.1714 128.652 70.0054 128.652 69.8014C128.652 69.5967 128.817 69.4314 129.021 69.4314C129.225 69.4314 129.39 69.5967 129.39 69.8014Z",
    fill: "#8FB3C6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.964 70.8394H129.583L129.205 68.384C129.723 68.384 130.198 68.6711 130.441 69.1297L130.615 69.4604C130.677 69.5752 130.721 69.6981 130.748 69.8254L130.964 70.8394Z",
    fill: "#8FB3C6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M124.417 72.6683H120.357",
    stroke: "#8FB3C6",
    strokeWidth: 0.91716
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.154 72.1147H124.242V71.1263H126.168C126.712 71.1263 127.154 71.5687 127.154 72.1147Z",
    fill: "#8FB3C6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.498 76.0953C126.498 76.9034 125.845 77.5585 125.039 77.5585C124.233 77.5585 123.58 76.9034 123.58 76.0953C123.58 75.2873 124.233 74.6321 125.039 74.6321C125.845 74.6321 126.498 75.2873 126.498 76.0953Z",
    fill: "#8FB3C6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.988 76.0953C122.988 74.9597 123.907 74.0393 125.04 74.0393C126.172 74.0393 127.09 74.9597 127.09 76.0953",
    fill: "#8FB3C6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.758 74.5294C132.4 74.2236 131.935 74.0389 131.428 74.0389C130.296 74.0389 129.377 74.9599 129.377 76.0956H130.929L132.758 74.5294Z",
    fill: "#8FB3C6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.885 76.0953C132.885 76.9034 132.232 77.5585 131.426 77.5585C130.62 77.5585 129.967 76.9034 129.967 76.0953C129.967 75.2873 130.62 74.6321 131.426 74.6321C132.232 74.6321 132.885 75.2873 132.885 76.0953Z",
    fill: "#8FB3C6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.04 76.0953C132.04 76.4348 131.766 76.7106 131.427 76.7106C131.088 76.7106 130.812 76.4348 130.812 76.0953C130.812 75.7559 131.088 75.4801 131.427 75.4801C131.766 75.4801 132.04 75.7559 132.04 76.0953Z",
    fill: "#355468"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.653 76.0953C125.653 76.4348 125.379 76.7106 125.04 76.7106C124.701 76.7106 124.426 76.4348 124.426 76.0953C124.426 75.7559 124.701 75.4801 125.04 75.4801C125.379 75.4801 125.653 75.7559 125.653 76.0953Z",
    fill: "#355468"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.234 72.0486C131.55 72.0486 131.806 72.3057 131.806 72.622C131.806 72.8298 131.695 73.012 131.531 73.1125L131.234 72.0486Z",
    fill: "#EACE24"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M10.958 41.7219H16.0873C18.5298 41.7219 20.3395 41.1092 21.5164 39.8837C22.6932 38.6582 23.2817 37.0316 23.2817 35.004C23.2817 33.0432 22.6932 31.5169 21.5164 30.4251C20.3617 29.3333 18.763 28.7874 16.7202 28.7874C14.8772 28.7874 13.3339 29.2999 12.0905 30.3249C10.847 31.3275 10.2253 32.6422 10.2253 34.2687H0.599528C0.599528 31.7286 1.27677 29.4559 2.63126 27.4505C4.00795 25.4229 5.91756 23.8409 8.36008 22.7045C10.8248 21.5682 13.5338 21 16.487 21C21.6163 21 25.6354 22.2366 28.5442 24.7099C31.453 27.1609 32.9074 30.5477 32.9074 34.8703C32.9074 37.0985 32.2302 39.1484 30.8757 41.0201C29.5212 42.8917 27.7448 44.3289 25.5465 45.3316C28.2777 46.3119 30.3095 47.7825 31.6417 49.7433C32.9962 51.7041 33.6735 54.0214 33.6735 56.6952C33.6735 61.0178 32.0969 64.4826 28.9439 67.0896C25.813 69.6965 21.6607 71 16.487 71C11.6464 71 7.68284 69.7188 4.59638 67.1564C1.53213 64.594 0 61.2072 0 56.996H9.62575C9.62575 58.8231 10.303 60.316 11.6575 61.4746C13.0342 62.6332 14.7217 63.2126 16.7202 63.2126C19.0072 63.2126 20.7947 62.611 22.0826 61.4078C23.3927 60.1823 24.0477 58.5668 24.0477 56.5615C24.0477 51.7041 21.3832 49.2754 16.054 49.2754H10.958V41.7219Z",
    fill: "url(#paint10_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 84.1777,
    y1: 64.8701,
    x2: 84.1777,
    y2: 71.4099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7337"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 85.1367,
    y1: 63.0641,
    x2: 85.1367,
    y2: 65.5639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7337"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 83.0703,
    y1: 24.9066,
    x2: 83.0703,
    y2: 29.1196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7337"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 54.3164,
    y1: 37.7681,
    x2: 54.3164,
    y2: 38.5896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7337"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 59.1113,
    y1: 50.7631,
    x2: 59.1113,
    y2: 58.8245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7337"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 59.0684,
    y1: 58.3684,
    x2: 59.0684,
    y2: 61.9513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7337"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 49.6641,
    y1: 52.5463,
    x2: 49.6641,
    y2: 60.1598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7337"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 60.0762,
    y1: 35.3037,
    x2: 60.0762,
    y2: 36.1994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7337"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 67.1699,
    y1: 33.0645,
    x2: 67.1699,
    y2: 33.9602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7337"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 75.6387,
    y1: 30.6013,
    x2: 75.6387,
    y2: 31.497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7337"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 0,
    y1: 21,
    x2: 0,
    y2: 71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7337"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgB3);
export default __webpack_public_path__ + "static/media/b3.98f404f86fb2c585ee8d213c448165c3.svg";
export { ForwardRef as ReactComponent };